<dt-modal-content [size]="'big'" (closeClick)="close(false)">
  <ng-template #title>{{ teamsTasksService.getTaskTypeName(task) }}</ng-template>
  <ng-template #content>
    <ng-template [cdkPortalOutlet]="portal" (attached)="portalAttached($any($event))"></ng-template>
  </ng-template>
  <ng-template #footer>
    <button mat-raised-button color="accent" i18n (click)="close(true)" [disabled]="readonly">Speichern</button>
    <button mat-stroked-button color="accent" i18n (click)="close(false)">Verwerfen</button>
  </ng-template>
</dt-modal-content>
